import tippy from 'tippy.js';

document.querySelectorAll('[data-toggle="tooltip"]').forEach(node => {
    tippy(node, {
        content: node.getAttribute('data-title') || node.getAttribute('title'),
    });
});
